var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmarkcirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.498-19.2871L62.207-46.0449C62.8418-46.6797 63.2324-47.5586 63.2324-48.584C63.2324-50.5371 61.6211-52.0996 59.668-52.0996C58.6914-52.0996 57.8125-51.7578 57.2266-51.0742L30.3711-24.4141C29.6875-23.7305 29.3457-22.9004 29.3457-21.875C29.3457-19.873 30.9082-18.2129 32.959-18.2129C33.9355-18.2129 34.8145-18.6523 35.498-19.2871ZM57.0801-19.2871C57.7148-18.6523 58.6426-18.2129 59.668-18.2129C61.6211-18.2129 63.2324-19.873 63.2324-21.875C63.2324-22.9004 62.8418-23.7305 62.207-24.4141L35.4004-51.0742C34.7168-51.7578 33.8867-52.0996 32.959-52.0996C30.9082-52.0996 29.3457-50.5371 29.3457-48.584C29.3457-47.5586 29.6875-46.6797 30.3711-46.0449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkcirclefill);
export default __webpack_public_path__ + "static/media/xmark.circle.fill.ab0aa5b6be09f6a71cd783973549919c.svg";
export { ForwardRef as ReactComponent };